import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Navbar,
  NavbarBrand,
  Row,
} from 'reactstrap';
import { FaPlus, FaTimes } from 'react-icons/fa';
import { FileContext, IAuntiesHouseFinancialTracking } from './FileContext';
import {
  DomainContext,
  FILE_TYPE_AUNTIES_HOUSE,
  IAuntiesHouseFinancialTrackingCategory,
} from '../../contexts/DomainContext';
import { authAxios } from '../../services/AxiosService';
import { notifyError, notifySuccess } from '../../services/ToastService';
import { useParams } from 'react-router';
import { LeavePageConfirm } from '../LeavePageConfirm/LeavePageConfirm';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { disabledSelectStyles } from '../../utils/StylingUtils';
import { RequiredLabel } from '../../components/RequiredLabel';
import { useWindowDimensions } from '../../hooks/WindowHooks';

export const FileAuntiesHouseFinancialTracking = () => {
  const fileContext = useContext(FileContext);
  const domainContext = useContext(DomainContext);
  const auntiesHouseFinancialTracking = fileContext.auntiesHouseFinancialTracking;
  const auntiesHouseFinancialTrackingCategories = domainContext.auntiesHouseFinancialTrackingCategories;
  const [changedAuntiesHouseFinancialTrackingLength, setChangedAuntiesHouseFinancialTrackingLength] = useState(0);
  const { xs, sm } = useWindowDimensions();
  const mobile = xs || sm;
  const params = useParams<{ fileId: string; tab?: string }>();
  const [isDirty, setIsDirty] = useState(false);
  const [trySave, setTrySave] = useState(false);
  const [isEditingAllowed] = useState(true);

  useEffect(() => {
    if (changedAuntiesHouseFinancialTrackingLength > 0) {
      var elmt2 = document.getElementById('select-field');
      if (elmt2) {
        elmt2.focus();
        elmt2.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [changedAuntiesHouseFinancialTrackingLength]);

  const formatCurrencyCommas = (amount: string | undefined) => {
    if (amount) {
      return amount
        .toString()
        .replace(/[, ]+/g, '')
        .replace(/-[^0-9.]/g, '')
        .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
    } else {
      return '';
    }
  };

  const formatCurrencyCommasTwoDigits = (amount: string | undefined) => {
    if (amount) {
      const floatToUse = parseFloat(amount.toString().replace(/[, ]+/g, ''));
      return Number.isNaN(floatToUse)
        ? '0.00'
        : floatToUse
            .toFixed(2)
            .toString()
            .replace(/-[^0-9.]/g, '')
            .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
    } else {
      return '';
    }
  };

  const saveFile = () => {
    if (
      params.fileId &&
      fileContext.fileTypeId &&
      fileContext.stageId &&
      fileContext.createdDate &&
      !auntiesHouseFinancialTracking.some(
        (f) => !f.auntiesHouseFinancialTrackingCategoryId || !f.serviceProvider || !f.dateProvided || !f.amount
      )
    ) {
      const data = fileContext.getEditData();

      authAxios.post('/api/files/update', data).then((response) => {
        if (response.data.status === 'OK') {
          setIsDirty(false);
          notifySuccess('File updated.');
          fileContext.setFileFromAttributes();
        } else {
          notifyError(response.data.errorMessage);
        }
      });
      let AHData = fileContext.getAuntiesHouseData(params.fileId);
      AHData.auntiesHouseFinancialTracking = AHData.auntiesHouseFinancialTracking?.sort(
        (a: IAuntiesHouseFinancialTracking, b: IAuntiesHouseFinancialTracking) => {
          if (a.dateProvided && b.dateProvided) {
            return a.dateProvided - b.dateProvided;
          } else {
            if (a.dateProvided === 0) {
              return 1;
            }
            if (b.dateProvided === 0) {
              return -1;
            }
            return 0;
          }
        }
      );
      authAxios.post('/api/files/update-aunties-house', AHData).then((response) => {
        if (response.data.status === 'OK') {
          console.log('PM updated :)');
        } else {
          console.log('PM not updated :(');
        }
      });
    } else {
      setTrySave(true);
    }
  };

  return (
    <>
      <LeavePageConfirm isDirty={isDirty} />
      <Navbar color={'light'} light={true} expand={'xs'} className={'border-bottom d-flex flex-wrap sticky-top'}>
        <NavbarBrand className={'w-mobile-100'}>Financial Tracking</NavbarBrand>
        <div
          className={'d-flex flex-grow-1 justify-content-end flex-wrap navbar-actions'}
          style={{ rowGap: '0.5rem', columnGap: '0.5rem' }}
        >
          {params.fileId && (
            <Button color={'primary'} className={'w-mobile-100'} onClick={() => saveFile()}>
              Save Financial Tracking
            </Button>
          )}
        </div>
      </Navbar>
      <Container fluid={true} className={'my-3'}>
        <Card>
          <CardHeader className={'d-flex align-items-center'}>Aunties House Financial Tracking</CardHeader>
          <CardBody className={'p-0'}>
            <ListGroup flush={true}>
              <ListGroupItem className={'py-2 d-none d-md-block'}>
                <Row style={{ paddingRight: 42 }} className='row--condensed'>
                  <Col style={{ flexGrow: 1.4 }}>
                    <RequiredLabel
                      required={auntiesHouseFinancialTracking.some((p) => !p.auntiesHouseFinancialTrackingCategoryId)}
                    >
                      Category
                    </RequiredLabel>
                  </Col>
                  <Col>
                    <Label required={auntiesHouseFinancialTracking.some((p) => !p.description)}>Description</Label>
                  </Col>
                  <Col>
                    <RequiredLabel required={auntiesHouseFinancialTracking.some((p) => !p.serviceProvider)}>
                      Service Provider
                    </RequiredLabel>
                  </Col>
                  <Col style={!mobile ? { flexGrow: 0.9, flexShrink: 0, flexBasis: 0 } : {}}>
                    <RequiredLabel required={auntiesHouseFinancialTracking.some((p) => !p.dateProvided)}>
                      Date Provided
                    </RequiredLabel>
                  </Col>
                  <Col style={{ flexGrow: 0.7 }}>
                    <RequiredLabel required={auntiesHouseFinancialTracking.some((p) => !p.amount)}>
                      Amount ($)
                    </RequiredLabel>
                  </Col>
                </Row>
              </ListGroupItem>
              {auntiesHouseFinancialTracking.map((ft, index) => (
                <ListGroupItem key={ft.auntiesHouseFinancialTrackingId} className={'py-4'}>
                  <div className={'d-flex'}>
                    <div className={'flex-grow-1'}>
                      <Row className={'row--condensed'}>
                        <Col md={'auto'} style={!mobile ? { flexGrow: 1.4, flexShrink: 1, flexBasis: 0 } : {}}>
                          <Label className={'d-md-none'}>Category</Label>
                          <Select
                            styles={disabledSelectStyles}
                            name={'serviceType'}
                            options={auntiesHouseFinancialTrackingCategories}
                            placeholder={<span className='placeholder'>Select...</span>}
                            value={auntiesHouseFinancialTrackingCategories.find(
                              (c: IAuntiesHouseFinancialTrackingCategory) =>
                                c.auntiesHouseFinancialTrackingCategoryId === ft.auntiesHouseFinancialTrackingCategoryId
                            )}
                            onChange={(value: any) => {
                              setIsDirty(true);
                              fileContext.setAuntiesHouseFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  auntiesHouseFinancialTrackingCategoryId: value
                                    ? value.auntiesHouseFinancialTrackingCategoryId
                                    : '',
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                            }}
                            getOptionValue={(option: IAuntiesHouseFinancialTrackingCategory) =>
                              option.auntiesHouseFinancialTrackingCategoryId
                            }
                            getOptionLabel={(option: IAuntiesHouseFinancialTrackingCategory) => option.name}
                            isDisabled={!isEditingAllowed}
                            isClearable={true}
                          />
                          {trySave &&
                            !ft.auntiesHouseFinancialTrackingCategoryId &&
                            fileContext.fileTypeId === FILE_TYPE_AUNTIES_HOUSE && (
                              <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                            )}
                        </Col>
                        <Col>
                          <Label className={'d-md-none'}>Description</Label>
                          <Input
                            type='text'
                            value={ft.description}
                            onChange={(e) => {
                              const descriptionTemp = e.target.value;
                              fileContext.setAuntiesHouseFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  description: descriptionTemp,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                          />
                        </Col>
                        <Col>
                          <Label className={'d-md-none'}>Service Provider</Label>
                          <Input
                            type='text'
                            value={ft.serviceProvider}
                            onChange={(e) => {
                              const serviceProviderTemp = e.target.value;
                              fileContext.setAuntiesHouseFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  serviceProvider: serviceProviderTemp,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                          />
                          {trySave && !ft.serviceProvider && fileContext.fileTypeId === FILE_TYPE_AUNTIES_HOUSE && (
                            <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                          )}
                        </Col>
                        <Col
                          sm={12}
                          md={'auto'}
                          style={!mobile ? { flexGrow: 0.95, flexShrink: 0, flexBasis: 0, minWidth: 80 } : {}}
                        >
                          <Label className={'d-md-none'}>Date Provided</Label>
                          <DatePicker
                            selected={ft.dateProvided ? new Date(ft.dateProvided) : undefined}
                            name={'dateProvided'}
                            onChange={(date) => {
                              setIsDirty(true);
                              fileContext.setAuntiesHouseFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  dateProvided: date ? date.getTime() : undefined,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                            }}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            isClearable={true}
                            dateFormat='MMM dd, yyyy'
                            dropdownMode='select'
                            className={'date-picker rounded mb-0'}
                            placeholderText={'MMM dd, yyyy'}
                          />
                          {trySave && !ft.dateProvided && fileContext.fileTypeId === FILE_TYPE_AUNTIES_HOUSE && (
                            <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                          )}
                        </Col>
                        <Col sm={12} md={'auto'} style={!mobile ? { flexGrow: 0.75, flexShrink: 1, flexBasis: 0 } : {}}>
                          <Label className={'d-md-none'}>Amount ($)</Label>
                          <Input
                            type='text'
                            style={{ textAlign: 'right' }}
                            value={ft.amount}
                            onChange={(e) => {
                              const pAmount = e.target.value;
                              fileContext.setAuntiesHouseFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  amount: formatCurrencyCommas(pAmount),
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                            onBlur={(e) => {
                              const pAmount = e.target.value;
                              fileContext.setAuntiesHouseFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  amount: formatCurrencyCommasTwoDigits(pAmount),
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                            disabled={!isEditingAllowed}
                          />
                          {trySave && !ft.amount && (
                            <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                          )}
                        </Col>
                      </Row>
                    </div>
                    <div className={'d-none d-md-block'} style={{ width: 42 }}>
                      <Button
                        color={'link'}
                        className={'text-danger'}
                        onClick={() => {
                          setIsDirty(true);
                          fileContext.setAuntiesHouseFinancialTracking((oldFT) => [
                            ...oldFT.slice(0, index),
                            ...oldFT.slice(index + 1),
                          ]);
                        }}
                      >
                        <FaTimes />
                      </Button>
                    </div>
                  </div>
                </ListGroupItem>
              ))}
              <ListGroupItem
                tag={'button'}
                id={'add-new-service'}
                className='border-top'
                onClick={() => {
                  setIsDirty(true);
                  fileContext.setAuntiesHouseFinancialTracking((oldFT) =>
                    oldFT.concat([
                      {
                        auntiesHouseFinancialTrackingId: Math.random().toString(),
                        auntiesHouseFinancialTrackingCategoryId: '',
                        description: '',
                        serviceProvider: '',
                        dateProvided: 0,
                        amount: '',
                      },
                    ])
                  );
                  setChangedAuntiesHouseFinancialTrackingLength((s) => s + 1);
                }}
              >
                <FaPlus /> Add Financial Tracking
              </ListGroupItem>
            </ListGroup>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};
